import TemplateSearchField from '@components/Templates/TemplateSearchField';
import useTemplateSearchField from '@components/Templates/TemplateSearchField/useTemplateSearchField';
import HeaderBannerWrapper from '@components/HeaderBanner';
import { Box } from '@wix/design-system';
import s from './TemplateHeaderBanner.module.scss';

export const dataHooks = {
  templateHeaderBannerHeader: 'template-header-banner-header',
};

const TemplateHeaderBanner = ({ isMobileView }: { isMobileView: boolean }) => {
  const {
    onSearch,
    onSelect,
    setSearchInputValue,
    searchInputValue,
    clearSearchInputValue,
  } = useTemplateSearchField();

  const hasSearchBar = !isMobileView;

  return (
    <HeaderBannerWrapper
      isMobileView={isMobileView}
      className={isMobileView ? '' : s.bannerWrapperBoxShadowYellow}
      subtitleKey="marketplace.templates-page.banner-studio.subtitle"
      titleKey="marketplace.templates-page.banner-studio.title"
      dataHook={dataHooks.templateHeaderBannerHeader}
    >
      {hasSearchBar ? (
        <Box maxWidth="400px" width="100%">
          <TemplateSearchField
            value={searchInputValue}
            onChange={(e) => setSearchInputValue(e?.target?.value)}
            onSelect={(e) => onSelect(e)}
            onEnterPressed={onSearch}
            onClear={clearSearchInputValue}
          />
        </Box>
      ) : null}
    </HeaderBannerWrapper>
  );
};

export default TemplateHeaderBanner;
